import { Environment } from './environment';

export const drEnvironment: Environment = {
  name: 'dr',
  auth0Domain: 'login.sama.com',
  auth0ClientId: '4lEhwXoYJy8Qejd70DWV4iivqEeFxekP',
  annotationStoreServiceBaseUrl: 'https://annotation-store.dr.sama.com/v1',
  clientCalibrationBaseUrl: 'https://client-calibration-be.sama.com/api/v0',
  taskServiceBaseUrl: 'https://api.dr.sama.com/api/v0',
  assetServiceBaseUrl: 'https://assets.dr.sama.com',
  authorizationServiceBaseUrl: 'https://sama-authorization-server.dr.sama.com',
  autoQaServiceBaseUrl: 'https://auto-qa.dr.sama.com',
  checkShaderErrors: false,
  draftSavePeriod: 60_000,
  featureFlagServiceBaseUrl: 'https://labapi.sama.com/v2.0',
  outputMinHeight: 800,
  previewWorkspacePointCloudAssetUrl:
    'https://assets.dr.sama.com/api/v1/assets/3e404bb1-30e9-41f0-9823-6366dae3cce5',
  targetEnhancedPointCount: 1_000_000,
  samplingBackendServiceBaseUrl: 'https://sampling-be.dr.sama.com',
  samplingPortalServiceBaseUrl: 'https://portal.dr.sama.com',
  seedDataPointCloudTaskId: '6480ab8d2be8523e7ea3158e',
  seedDataSensorFusionTaskId: '6480ab8d2be8523e7ea3158e',
  settingsServiceBaseUrl: 'https://sama-settings-be.dr.sama.com/api/v0',
  sh3BaseUrl: 'https://api.dr.sama.com',
  shouldDebounceRendering: true,
  shouldForceWebglContextLoss: true,
  shouldMakeHackyStoreForImageAnnotationTests: false,
  shouldSendDebugLogs: true,
  shouldSendErrorsToRollbar: true,
  shouldShowAddRandomShapes: false,
  shouldUseSegmentTracker: true,
  shouldUseResizeObserver: true,
};
